"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _constants = require("../../constants");

var _default = (0, _styles.withStyles)(() => ({
  root: {
    padding: 0,
    '& > * + *': {
      borderLeft: `1px solid ${_constants.colours.border}`
    }
  }
}))(_core.CardActions);

exports.default = _default;